import React, { Component } from 'react'
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import classes from './VideoPlayerControls.module.scss';

import FlexRow from 'Flow2/components/UI/Container/FlexRow';
import FlexColumn from 'Flow2/components/UI/Container/FlexColumn';

import { SkipForward, SkipBackward } from 'Flow2/components/VideoPlayer/Controls/SkipSeconds';
import { FrameForward, FrameBackward } from 'Flow2/components/VideoPlayer/Controls/SkipFrame';
import { GrabThumbnail } from 'Flow2/components/VideoPlayer/Controls/GrabThumbnail';
import { CutTimeLine } from 'Flow2/components/VideoPlayer/Controls/Cut'; 
import Cut from 'Flow2/components/VideoPlayer/Controls/Cut';

const injectData = (props) => {
	const inject = (Component) => {
		return (<Component {...props}  />);
	}
	return inject;
}

export const STANDARD_CONTROLS = [Cut, GrabThumbnail, SkipBackward, FrameBackward, FrameForward, SkipForward];

export const STANDARD_EXTRA_CONTROLS = [CutTimeLine];

class VideoPlayerControls extends Component {
	
	constructor(props) {
		super(props);
		this.state = { ...this.initState(props) }
	};

	initState = (props) => {
		const state = {}

		return state;
	}

	componentWillReceiveProps = (nextProps) => {
		if(!Object.is(this.props.video, nextProps.video)) {
			nextProps.video.addEventListener('timeupdate', this.onTimeUpdate);
		}
		
		if (this.props.clip.id !== nextProps.clip.id) {
			const state = { ...this.state, ...this.initState(nextProps) }
			this.setState({ ...state });
		}
	}
	
	onTimeUpdate = (evt) => {
		// nothing to do
	}

	/*
	onTimeBasedMeta = () => {
		this.props.timeBasedMeta();
	}
	*/
	renderControls = (controls = []) => {
		const injectedControls = controls.map(control => {
			return injectData(this.props)(control);
		});
		return injectedControls;
	}

	render = () => {
		const controls = this.props.controls || STANDARD_CONTROLS;
		const extraControls = this.props.extraControls || STANDARD_EXTRA_CONTROLS;
        
        return (
			<FlexColumn>
				<div>
                    { this.renderControls(extraControls) }
                </div>
				<FlexRow className={classes.ControlButtons}>
					{ this.renderControls(controls) }
				</FlexRow>
			</FlexColumn>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {}
}


const mapDispatchToProps = (dispatch) => {
	return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(VideoPlayerControls));
